"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_device_detect_1 = require("react-device-detect");
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
const package_1 = require("../../package");
const constants_1 = require("../constants");
const use_theme_1 = __importDefault(require("../hooks/use-theme"));
const tailwind_1 = __importDefault(require("../utils/tailwind"));
const provider_select_1 = require("./provider-select");
function priorityToText(priority) {
    switch (priority) {
        case constants_1.Priorities.Recent:
            return 'Recent';
        case constants_1.Priorities.Popular:
            return 'Popular';
        case constants_1.Priorities.Default:
        default:
            return 'More';
    }
}
const styles = (0, tailwind_1.default)({
    spacer: `tw-h-10`,
    title: `
    tw-pb-2
    tw-text-md
    tw-font-medium
    tw-sticky
    tw-top-0
    tw-z-10
    `,
    verticalContainer: `
    tw-flex
    tw-flex-col
    tw-overflow-hidden
    tw-h-full
    ${react_device_detect_1.isMobile ? 'tw-gap-y-4' : 'tw-gap-y-1'}
    ${react_device_detect_1.isMobile ? 'tw-w-80' : 'tw-w-48'}
    ${react_device_detect_1.isMobile ? 'md:tw-w-96' : 'md:tw-w-64'}`,
    scrollableList: `
    tw-flex
    tw-flex-col
    tw-overflow-y-auto
    tw-overflow-x-hidden
    tw-overscroll-contain
    tw-pr-1`,
    subtitle: `
    tw-font-medium
    tw-text-sm
    tw-pb-6`,
    flexColumn: `
    tw-flex
    tw-flex-col`,
    columnFooter: `
    tw-flex
    tw-sticky
    ${react_device_detect_1.isMobile ? 'tw-py-4' : 'tw-pt-4'}
    ${react_device_detect_1.isMobile ? '' : 'tw-bottom-0'}
    ${react_device_detect_1.isMobile ? 'tw-justify-center' : 'tw-justify-end'}
    tw-gap-x-2`,
    columnSearchableFooter: `
    tw-justify-between
    `,
    version: `
    tw-text-xs
    tw-leading-5
    tw-font-mono
    tw-font-thin
    tw-self-end`,
    noMatchesContainer: `
    tw-h-full
    tw-flex
    tw-flex-col
    tw-items-center
    tw-justify-center`,
    container: `
    tw-flex-grow`,
    noMatchesSpan: `
    tw-font-normal
    tw-align-center`,
    inputContainer: `
    tw-flex
    tw-self-end`,
    input: `
    tw-text-sm
    tw-font-medium
    placeholder:tw-font-medium
    placeholder:tw-text-current
    placeholder:tw-text-align-end
    focus-visible:tw-outline-none
    `,
    // todo: figure out a way to handle the placeholder color with the theme
});
function Tray({ providers: providersByPriority, title, onClickProvider, selectedProvider, search, onSearch, }) {
    const theme = (0, use_theme_1.default)();
    const nPriorities = providersByPriority.reduce((acc, [prio]) => {
        if (!acc.includes(prio))
            acc.push(prio);
        return acc;
    }, []);
    const searchElem = (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: `${styles.columnFooter} ${onSearch ? styles.columnSearchableFooter : ''}`, style: {
            background: theme.background,
        } },
        onSearch && (react_1.default.createElement("div", { className: styles.inputContainer },
            react_1.default.createElement("input", { className: styles.input, style: {
                    background: theme.background,
                    color: theme.textTertiary,
                }, placeholder: "Search for a wallet", value: search || '', onChange: (event) => { var _a; return onSearch((_a = event.target) === null || _a === void 0 ? void 0 : _a.value); } }))),
        react_1.default.createElement("span", { className: styles.version, style: { color: theme.muted } }, package_1.version))), [theme, search, onSearch]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles.verticalContainer },
            react_1.default.createElement("div", { className: `${styles.scrollableList} rc-tray-ios-fix` },
                react_1.default.createElement("div", { className: styles.title, style: { color: theme.textSecondary, background: theme.background } },
                    react_1.default.createElement("h1", null, title),
                    react_device_detect_1.isMobile && searchElem),
                !providersByPriority.length && (react_1.default.createElement("div", { className: styles.noMatchesContainer },
                    react_1.default.createElement("span", { className: styles.noMatchesSpan, style: { color: theme.textTertiary } }, "No matches"))),
                providersByPriority.map(([priority, providers], i) => (react_1.default.createElement("div", { key: priority, className: nPriorities.length === 1 || i > 0 ? styles.container : '' },
                    !react_device_detect_1.isMobile && nPriorities.length !== 1 && (react_1.default.createElement("span", { className: styles.subtitle, style: { color: theme.textSecondary } }, priorityToText(priority))),
                    react_1.default.createElement("div", { className: styles.verticalContainer },
                        providers.map(([providerKey, provider]) => {
                            return (react_1.default.createElement(provider_select_1.ProviderSelect, { key: providerKey, provider: provider, selected: provider.name === selectedProvider, onClick: () => onClickProvider(providerKey) }));
                        }),
                        react_device_detect_1.isMobile && react_1.default.createElement("span", { className: styles.spacer }))))),
                !react_device_detect_1.isMobile && searchElem))));
}
exports.default = Tray;
//# sourceMappingURL=tray.js.map